/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import ProgramStep from "@shared/Program/ProgramStep/ProgramStep";
import {StepType} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";
import programStepDiscriminator from "@shared/Program/ProgramStep/helpers/ProgramStepDiscriminator";
import {Type} from "class-transformer";
import LockerState from "@shared/Program/Locaker/LockerState";



export default class SectionProgramStep extends ProgramStep {

	@Type(() => LockerState)
	lockerState: LockerState = new LockerState()

	@Type(() => ProgramStep, programStepDiscriminator)
	subStepList: ProgramStep[] = []

	stepType = StepType.SECTION


	constructor(name: string = "", description: string = "", subStepList: ProgramStep[] = []) {
		super(name, description);
		this.subStepList = subStepList
	}

	hasPaymentLocker(){
		return this.lockerState.hasPaymentLocker && this.lockerState.paymentAmount > 0
	}
	isLockedByPayment(){
		return this.lockerState.isLockedByPayment && this.lockerState.paymentAmount > 0
	}
	isLocked(){
		return this.lockerState.isLocked()
	}

	expandItemForOwnerId(ownerId){
		if(ownerId){
			this.expandedForOwnerIds.pushUnique(ownerId)
		}
	}
	collapseItemForOwnerId(ownerId){
		this.expandedForOwnerIds.deleteItem(ownerId)
	}
	addProgramStep(programStep: ProgramStep){
		if(this.subStepList.findIndex(step => step.id === programStep.id) < 0){
			this.subStepList.push(programStep)
			return true
		}
		return false
	}

}



